import React, { useContext } from 'react';
import HTMLContent from './HTMLContent'; 
import { ThemeContext } from "../context/ThemeProvider";
import { getStudyIconBg } from "../utils/themeUtils";
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faLightbulb,
  faTag,
  faLayerGroup
} from '@fortawesome/free-solid-svg-icons';

const ExplanationComponent = ({ explanation, topic, sub_domain }) => {
  const { theme, currentTheme } = useContext(ThemeContext);

  // Helper function to get icon background color
  const getIconBg = () => {
    return getStudyIconBg(theme, currentTheme);
  };

  // Helper function for text color
  const getTextColor = () => {
    return currentTheme === 'light' 
      ? theme?.text?.light
      : theme?.text?.dark;
  };
  const getExplanationBackground = () => {
    return currentTheme === 'light' ? theme?.homeCard?.end_light : theme?.homeCard?.end_dark
  };

  // Animation variants
  const contentVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { 
      opacity: 1, 
      y: 0,
      transition: { 
        duration: 0.3,
        type: "spring",
        stiffness: 300,
        damping: 20
      }
    }
  };

  const tagVariants = {
    hover: { 
      scale: 1.05,
      transition: { type: "spring", stiffness: 400, damping: 10 }
    }
  };

  return (
    <motion.div
      initial="initial"
      animate="animate"
      variants={contentVariants}
      className="mt-6"
    >
      {/* Explanation Header */}
      <div className="flex items-center mb-4">
        <div 
          className="w-10 h-10 rounded-full flex items-center justify-center mr-3"
          style={{ backgroundColor: getIconBg() }}
        >
          <FontAwesomeIcon 
            icon={faLightbulb} 
            className="text-white" 
          />
        </div>
        <h3 
          className="text-lg font-semibold"
          style={{ color: getTextColor() }}
        >
          Explanation
        </h3>
      </div>

      {/* Explanation Content */}
      <div 
        className="pl-13 mb-6 rounded-lg py-3 px-4"
        style={{ 
          backgroundColor: getExplanationBackground(),
          marginLeft: '3.25rem'
        }}
      >
        <HTMLContent htmlContent={explanation ?? ""} />
      </div>

      {/* Topic and Subdomain Tags */}
      <div className="flex flex-wrap items-center gap-3 mt-4 pl-13" style={{ marginLeft: '3.25rem' }}>
        {topic && (
          <motion.div
            whileHover="hover"
            variants={tagVariants}
            className="flex items-center py-2 px-4 rounded-lg"
            style={{ 
              backgroundColor: getExplanationBackground(),
              border: `1px solid ${getIconBg()}30`
            }}
          >
            <FontAwesomeIcon 
              icon={faTag} 
              className="mr-2"
              style={{ color: getIconBg() }}
            />
            <span style={{ color: getTextColor() }}>
              {topic}
            </span>
          </motion.div>
        )}

        {sub_domain && (
          <motion.div
            whileHover="hover"
            variants={tagVariants}
            className="flex items-center py-2 px-4 rounded-lg"
            style={{ 
              backgroundColor: getExplanationBackground(),
              border: `1px solid ${getIconBg()}30`
            }}
          >
            <FontAwesomeIcon 
              icon={faLayerGroup} 
              className="mr-2"
              style={{ color: getIconBg() }}
            />
            <span 
              className="text-sm italic"
              style={{ color: getTextColor() }}
            >
              {sub_domain}
            </span>
          </motion.div>
        )}
      </div>
    </motion.div>
  );
};

export default ExplanationComponent;